import { Typography } from '@mui/material';
import { styled } from '@mui/system';

export const CustomCaptionTextStyled = styled(Typography)(({ bold }) => ({
  fontSize: 12,
  fontWeight: bold ? 'bold' : '',
}));
